export default {
  setFetchingMe(state, value) {
    state.fetchingMe = value
  },

  setFetchingContentTree(state, value) {
    state.fetchingContentTree = value
  },

  setContentTreeSaving(state, value) {
    state.contentTreeSaving = value
  },

  setClientData(state, data) {

    state.memberships = {
      ids: [],
      index: {}
    }

    data.memberships.forEach((membership) => {
      state.memberships.index = {
        ...state.memberships.index,
        [membership.id]: membership
      }
    })

    state.memberships.ids = Object.keys(state.memberships.index)

    delete data.memberships
    state.data = data
  },

  setContentTree(state, modules) {
    const tree = []

    modules.sort((a, b) => a.name > b.name)
    modules.forEach((module) => {
      const module_mapped = {
        id: module.id,
        name: module.name,
        children: [],
        type: 'module',
        is_hidden: module.is_hidden,
        checked: !module.is_hidden,
        parentID: null
      }

      module.components.sort((a, b) => a.order - b.order)
      module.components.forEach((component) => {
        const component_mapped = {
          id: component.id,
          name: component.name,
          children: [],
          type: 'component',
          is_hidden: component.is_hidden,
          checked: !component.is_hidden,
          parentID: module.id
        }

        component.topics.sort((a, b) => a.order - b.order)
        component.topics.forEach((topic) => {
          const topic_mapped = {
            id: topic.id,
            name: `${topic.name} (${topic.items.length} items)`,
            children: [],
            type: 'topic',
            is_favorite: module.is_favorite,
            parentID: component.id
          }
          component_mapped.children.push(topic_mapped)
        })
        module_mapped.children.push(component_mapped)
      })
      tree.push(module_mapped)
    })

    state.contentTree = tree
  },

  setConfirmationSent(state, sent) {
    state.confirmationSent = sent
  },

  removeFavoriteTopic(state, id) {
    delete state.favorite_topics.index[id]
    state.favorite_topics.ids = Object.keys(state.favorite_topics.index)
  },

  // update the 'checked' state of a module's components if the module
  // checked state is changed
  syncContentTreeCheckedState(state, moduleID) {
    const modules = JSON.parse(JSON.stringify(state.contentTree))
    for (let i=0; i<modules.length; i++) {
      if (modules[i].id === moduleID) {
        let allHidden = true
        for (let j=0; j<modules[i].children.length; j++) {
          if (modules[i].children[j].checked === true) {
            allHidden = false
            break
          }
        }
        if (allHidden) {
          modules[i].checked = false
        }
      }
    }
    state.contentTree = modules
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/mutations.js